import { StyleSheet } from 'react-native';
import Theme from 'Theme';
import { Device } from 'DeviceUtils';

const baseStyles = {
    outerItemContainer: {
        marginHorizontal: Device.isTabletOrWeb ? '20%' : Theme.primaryMargin,
        marginBottom: -1
    },
    outerItemContainerLast: {
        marginBottom: 0
    },
    outerItemContainerActive: {
        backgroundColor: 'rgba(0, 0, 0, 0.5)'
    },
    innerItemContainer: {
        flex: 1,
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center',
        marginVertical: 10
    },
    logoNameContainer: {
        marginLeft: 14,
        flexDirection: 'row',
        flexGrow: 1
    },
    itemName: {
        fontFamily: Theme.regularFont,
        fontSize: 20,
        textAlign: 'left',
        marginLeft: 20
    },
    itemDivider: {
        marginVertical: 0
    },
    dragHandler: {
        flexGrow: 0,
        marginRight: 10
    },
    itemNumber: {
        flexGrow: 0,
        height: '60%',
        opacity: 0.95,
        paddingHorizontal: 4,
        backgroundColor: '#FFFFFF',
        borderRadius: 4,
        alignItems: 'center',
        textAlign: 'center',
        justifyContent: 'center'
    },
    itemNumberText: {
        color: '#404040',
        fontFamily: Theme.regularFont,
        fontSize: Theme.primaryFontSize,
        letterSpacing: 1.5
    }
};

export default StyleSheet.create(baseStyles);
